import axios from 'axios';
const API_PREFIX = process.env.REACT_APP_API_PREFIX;

export const getControlPanelUsers = async (filter) => {
  return await axios
    .get(
      `${API_PREFIX}/controlpanel/users?_page=${filter._page}&_limit=${filter._limit}&_sort=id&_order=desc&q=${filter.q}&isdelete=${filter.isdelete}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getLogs = async (filter) => {
  return await axios
    .get(
      `${API_PREFIX}/controlpanel/logs?_page=${filter._page}&_limit=${filter._limit}&_sort=id&_order=desc&q=${filter.q}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getCenters = async (filter) => {
  return await axios
    .get(
      `${API_PREFIX}/controlpanel/centers?_page=${filter._page}&_limit=${filter._limit}&_sort=id&_order=desc&q=${filter.q}&rrb=${filter.rrb}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getExams = async (filter) => {
  return await axios
    .get(
      `${API_PREFIX}/controlpanel/exams?_page=${filter._page}&_limit=${filter._limit}&_sort=${filter._sort}&_order=${filter._order}&q=${filter.q}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getReports = async (filter) => {
  return await axios
    .get(
      `${API_PREFIX}/controlpanel/reports?_page=${filter._page}&_limit=${filter._limit}&_sort=id&_order=desc&q=${filter.q}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getMinistryExams = async (filter) => {
  return await axios
    .get(
      `${API_PREFIX}/controlpanel/ministry-exams?_page=${filter._page}&_limit=${filter._limit}&_sort=${filter._sort}&_order=${filter._order}&q=${filter.q}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getDivisionCities = async (filter) => {
  return await axios
    .get(
      `${API_PREFIX}/controlpanel/division-cities?_page=${filter._page}&_limit=${filter._limit}&_sort=id&_order=desc&q=${filter.q}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};

export const getControlPanelDashboard = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');
  return await axios
    .get(`${API_PREFIX}/controlpanel/dashboard${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};

export const getControlPanelSaveSubmitExamStats = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');

  return await axios
    .get(`${API_PREFIX}/controlpanel/saveSubStats${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
